const ReportSingleView = require('./ReportSingleView');
const ReportEditView = require('./ReportEditView');
const ReportAllView = require('./ReportAllView');

class ReportModal {
  constructor(modal) {
    this.modal = modal;
    this.wrapper = modal.find('.wrapper');
  }

  init() {
    this.bindElements();
  }

  bindElements() {
    this.modal.on('show.bs.modal', (e) => {
      this.onShowModal(e);
    });
  }

  onShowModal(e) {
    const btn = $(e.relatedTarget);
    const type = btn.data('type');

    switch (type) {
      case 'report-all':
        new ReportAllView(this.modal, btn).init();
        break;
      case 'report-edit':
        new ReportEditView(this.modal, btn).init();
        break;
      default:
        new ReportSingleView(this.modal, btn).init();
        break;
    }

    // this.animate();
  }

  animate() {
    this.wrapper.fadeTo(0, 0);
    setTimeout(() => {
      this.wrapper.fadeTo(200, 1);
    }, 300);
  }
}

module.exports = (el) => {
  new ReportModal($(el)).init();
};
